/*@ngInject*/
const PermissionsModel = function () {

    var permissions = {};

    this.getPermissions = function () {
        return permissions;
    };

    this.setPermissions = function (permissionsSummary) {
        permissions = permissionsSummary;
    };

};

angular.module('ums.configuration')
    .service('permissionsModel', PermissionsModel);
